// Este codigo fue generado por Github Copilot Chat
import { Component, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractControlValueAccessorComponent } from '../../helpers/abstract-control-value-accessor';

@Component({
  selector: 'app-date-picker',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './app-date-picker.component.html',
  styleUrls: ['./app-date-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppDatePickerComponent),
      multi: true
    }
  ]
})
export class AppDatePickerComponent extends AbstractControlValueAccessorComponent<string> {}
// Este codigo fue generado por Github Copilot Chat
